import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { IconButton } from '@mui/material'
import styles from './DialogClose.module.scss'

type DialogCloseProps = Readonly<{
  /** The dialog's safe path — the handler behind its cancel button. */
  onClose: () => void
}>

/**
 * The way out of a dialog, the same everywhere. It deliberately calls the
 * dialog's cancel handler rather than dismissing itself, so closing can never
 * confirm the thing the dialog was asking about.
 */
export function DialogClose({ onClose }: DialogCloseProps) {
  return (
    <IconButton aria-label="Close" className={styles.close} onClick={onClose} size="small">
      <CloseOutlinedIcon />
    </IconButton>
  )
}
